module.exports = __webpack_public_path__ + "img/system-lock.56e31988.png";